import * as React from "react";
import type { SVGProps } from "react";
const SvgElevatorIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fill="#858585"
      d="M3.92 1.12a.56.56 0 0 0-.56.56v24.64a.56.56 0 0 0 .56.56h20.16a.56.56 0 0 0 .56-.56V1.68a.56.56 0 0 0-.56-.56zm.56 1.12h19.04v23.52H22.4V6.72a.56.56 0 0 0-.56-.56H6.16a.56.56 0 0 0-.56.56v19.04H4.48zm7.84 1.12L11.2 5.04h2.24zm2.24 0 1.12 1.68 1.12-1.68zM6.72 7.28h6.72v18.48H6.72zm7.84 0h6.72v18.48h-6.72z"
    />
  </svg>
);
export default SvgElevatorIcon;
